import $ from 'jquery';

export default function handleFlyoutMenu(navWrapperClass, navItemWithFlyoutClass, flyoutClass, linkGroupClass, clonedLinkAdditionalText) {
    let $navWrapper = $('.' + navWrapperClass),
        $navItemWithFlyout = $navWrapper.find('.' + navItemWithFlyoutClass);

    $navItemWithFlyout.each(function(i, element){
        let $flyout = $(element).find('.' + flyoutClass),
            flyoutClassValue = $flyout.attr('class'),
            $linkToDuplicate = $(element).children('a').first(),
            $linkText = $linkToDuplicate.text();

        $flyout.attr('class', linkGroupClass);
        $flyout.wrap('<div class=' + flyoutClassValue + '>').parent();
        $linkToDuplicate.clone().insertBefore($flyout).text($linkText + ' ' + clonedLinkAdditionalText).addClass('cloned-link');
        $linkToDuplicate.replaceWith('<span>' + $linkText + '</span>');
    });
    $navWrapper.addClass('is-manipulated');
}